export default __webpack_public_path__ + "static/media/Redux-white-text.e07ca488.jpg";